import requestCustom from '@/utils/requestCustom'
import requestGo from '@/utils/requestGo' // 去旧IM：IM 接口改走自研 Go 后端
// 登录客户系统
export function loginCustom(data) {
    return requestCustom({
        url: `/login`,
        method: 'post',
        data
    })
}
// 获取客户端图片验证码
export function captchaImage() {
    return requestCustom({
        url: `/captchaImage`,
        method: 'get'
    })
}
// 从客户系统获取个人信息
export function getUserInfo() {
    return requestCustom({
        url: `/system/user/profile`,
        method: 'get'
    })
}
// 从客户系统获取IM登录token
export function getImToken() {
    return requestCustom({
        url: `/im/msg/getUserToken`,
        method: 'get'
    })
}
// 将图片上传到自己服务器
export function uploadImg(data) {
    return requestCustom({
        url: `/upload/upHx`,
        method: 'post',
        data
    })
}
// 发送消息到客户服务器
export function sendMsg(data) {
    // 旧前端用 senType(text/image/video/audio/goods)，自研 Go 后端用 type+customType，在此适配
    const senType = data.senType || 'text'
    const body = {
        toUser: data.toUser,
        toGroup: data.toGroup,
        sessionId: data.sessionId,
        content: data.content,
        type: senType === 'text' ? 'text' : 'custom',
        customType: senType === 'text' ? '' : senType
    }
    return requestGo({ url: `/im/msg/sendMsg`, method: 'post', data: body })
}
// 撤回消息 通知服务端 /msg/history/revocation
export function revocationMsg(data) {
    return requestGo({
        url: `/msg/history/revocation`,
        method: 'post',
        data
    })
}
// 回收群查询群成员信息 groupId
export function getOtherGroupInfo(groupId, fromHxId) {
    return requestGo({
        url: `/group/info/membersDetail?groupId=${groupId}&fromHxId=${fromHxId}`,
        method: 'get'
    })
}

// 回收群查询订单信息 groupId
export function getOrderInfo(groupId) {
    return requestCustom({
        url: `/account/krecycle/getInfoByGroupId/${groupId}`,
        method: 'get'
    })
}
// 销售查询订单信息 groupId
export function getSalesOrderInfo(groupId) {
    return requestGo({
        url: `/sessionList/getOrderInfoByGroup?toGroup=${encodeURIComponent(groupId || '')}`,
        method: 'get'
    })
}
// 单聊查询订单信息 groupId
export function getOrderByHxId(hxId) {
    return requestCustom({
        url: `/account/krecycle/getOrderByHxId/${hxId}`,
        method: 'get'
    })
}
// 单聊查询销售订单信息
export function getSaleOrderByHxId(hxId) {
    return requestCustom({
        url: `/need/myOrder/byHxId?HxId=${hxId}`,
        method: 'get'
    })
}

// 获取聊天快捷语
// export function getQuickWords() {
//   return requestCustom({
//       url: `/account/reply/allList`,
//       method: 'get'
//   })
// }
export function getQuickWords() {
    return requestCustom({
        url: `/account/reply/myList`,
        method: 'get'
    })
}

//添加快捷语
export function AddQuickWords(data) {
    return requestCustom({
        url: `/account/reply`,
        method: 'post',
        data
    })
}
//修改快捷语
export function EditQuickWords(data) {
    return requestCustom({
        url: `/account/reply`,
        method: 'put',
        data
    })
}
export function deleteQuickWords(id) {
    return requestCustom({
        url: `/account/reply/${id}`,
        method: 'delete'
    })
}
//删除快捷语
// 创建群聊
/**
 * 
 * @param {owner 
groupName
description
groupType 
other} groupId 
 * @returns 
 */
export function createPublicGroup(data) {
    const body = normalizeGoGroupPayload(data)
    return requestGo({
        url: `/im/msg/createPublicGroup`,
        method: 'post',
        data: body
    })
}
// 会话内搜索聊天记录
export function searchInSession(sessionId, content = '', type = 'text') {
    return requestGo({
        url: `/msg/history/searchInSession`,
        method: 'get',
        params: {
            sessionId,
            keyword: content,
            type,
            size: 50
        }
    }).then((res) => ({
        ...res,
        rows: res.rows || res.data || []
    }))
}

function normalizeHistoryRows(res) {
    return {
        ...res,
        rows: res.rows || res.data || []
    }
}

function buildHistoryParams(sessionId, id = '', limit = 20) {
    const params = { sessionId, size: limit }
    if (id) params.lastId = id
    return params
}

// 查看上下文
// 会话历史消息记录 sessionId
export function getHistoryMessageCustom(
    sessionId,
    id = '',
    type = 1,
    limit = 20
) {
    if (id && type === 1) {
        return requestGo({
            url: `/msg/history/list`,
            method: 'get',
            params: buildHistoryParams(sessionId, id, limit)
        }).then(normalizeHistoryRows)
    }
    if (id && type === 3) {
        return requestGo({
            url: `/msg/history/list`,
            method: 'get',
            params: buildHistoryParams(sessionId, id, limit)
        }).then(normalizeHistoryRows)
    }
    if (id && type === 2) {
        return Promise.resolve({ code: 200, msg: '操作成功', data: [], rows: [] })
    }
    return requestGo({
        url: `/msg/history/recentList`,
        method: 'get',
        params: { sessionId, size: limit }
    }).then(normalizeHistoryRows)
}

// 旧代码保留在此处以上：历史消息已切到 Go 后端，并补 rows 兼容旧组件。

/*
export function searchInSessionOld(sessionId, content = '', type = 'text') {
    return requestCustom({
        url: `/msg/history/searchInSession?sessionId=${sessionId}&content=${content}&type=${type}`,
        method: 'get'
    })
}

// 查看上下文
// 会话历史消息记录 sessionId

export function getHistoryMessageCustom(
    sessionId,
    id = '',
    type = 1,
    limit = 20
) {
    return requestGo({
        url: `/msg/history/recentList?sessionId=${sessionId}&type=${type}&limit=${limit}&id=${id}`,
        method: 'get'
    })
}
*/

// 搜索会话列表记录
export function searchInAllSession(
    content,
    formUser,
    searchType,
    type = 'text',
    scope = {}
) {
    return requestGo({
        url: `/msg/history/searchInAllSession`,
        method: 'get',
        timeout: 8000,
        params: {
            keyword: content,
            searchType,
            type,
            size: 30,
            scopeType: scope.type || 'all',
            groupCategory: scope.groupCategory
        }
    })
}
// 提交用户备注
export function saveOrUpdateOrDel(data) {
    return requestGo({
        url: `/userRemark/saveOrUpdateOrDel`,
        method: 'post',
        data
    })
}
// 用户备注列表
export function userRemarkList(fromHxId, toHxId = '') {
    return requestGo({
        url: `/userRemark/list?fromHxId=${fromHxId}&toHxId=${toHxId}`,
        method: 'get'
    })
}

// 获取会话列表
// export function sessionListList(params) {
//   // ?formUser=${formUser}
//   return requestCustom({
//     // url: `/sessionList/list?formUser=${data.formUser}&pageSize=${data.pageSize}&pageNum=${data.pageNum}&msgType=${data.msgType}`,
//     url: `/sessionList/list`,
//     method: 'get',
//     params
//   })
// }
export function sessionListList(params) {
    return requestGo({
        url: `/sessionList/h5/list`,
        method: 'get',
        params
    })
}
// // 解散群
export function rmGroup(data) {
    return requestGo({
        url: `/im/msg/rmGroup`,
        method: 'post',
        data
    })
}

// // 会话置顶
export function topOrCancel(data) {
    const body = {
        sessionId: data.sessionId,
        top: data.top !== undefined ? data.top : data.topType == 1
    }
    return requestGo({
        url: `/sessionList/topOrCancel`,
        method: 'post',
        data: body
    })
}

// 修改群信息
export function updateGroupSettings(data) {
    return requestGo({
        url: `/group/info/updateSettings`,
        method: 'post',
        data
    })
}

// 更新群公告
export function updateAnnouncement(data) {
    return requestGo({
        url: `/group/info/updateAnnouncement`,
        method: 'post',
        data
    })
}

// 获取所有旧IM用户
export function getHaveHxUserList(keyWords, fromHxId) {
    return requestGo({
        url: `/im/msg/getHaveHxUserList?keyWords=${encodeURIComponent(keyWords || '')}&fromHxId=${encodeURIComponent(fromHxId || '')}`,
        method: 'get'
    })
}

// 拉用户进群
export function addHxUserName(data) {
    return requestGo({
        url: `/group/info/addHxUserName`,
        method: 'post',
        data
    })
}
// 退出群聊
export function removeHxUserName(data) {
    return requestGo({
        url: `/group/info/removeHxUserName`,
        method: 'post',
        data
    })
}
// 设为群主
export function assignGroup(data) {
    return requestCustom({
        url: `/group/info/assignGroup`,
        method: 'post',
        data
    })
}
// 群公告（自研 Go 后端）
export function getGroupAnnouncement(groupId) {
    return requestGo({
        url: `/im/msg/getGroupAnnouncement?groupId=${groupId}`,
        method: 'get'
    })
}
// 群管理员/群主（自研 Go 后端）
export function listGroupAdmins(groupId) {
    return requestGo({
        url: `/im/msg/listGroupAdmins?groupId=${groupId}`,
        method: 'get'
    })
}
// 我加入的群（自研 Go 后端）
export function getJoinedGroupsGo() {
    return requestGo({
        url: `/im/msg/listGroupsUserJoined`,
        method: 'get'
    })
}
// 群详情（自研 Go 后端）
export function getGroupDetailGo(groupId) {
    return requestGo({
        url: `/im/msg/getGroup?groupId=${groupId}`,
        method: 'get'
    })
}
// 获取系统字典
export function getDict(dictType) {
    return requestCustom({
        url: '/system/dict/data/type/' + dictType,
        method: 'get'
    })
}
// 通知后台创建会话
export function sessionListAdd(data) {
    return requestCustom({
        url: '/sessionList',
        method: 'post',
        data
    })
}

// 发送短信提醒
// 通知后台创建会话
export function sendSortMsg(hxId, type) {
    return requestCustom({
        url: `/nd/login/sendDX?hxId=${hxId}&type=${type}`,
        method: 'get'
    })
}

//填写账号密码
export function addAccountPassWord(data) {
    return requestCustom({
        url: `/account/order/rec/editSaleAccount`,
        method: 'put',
        data
    })
}

//获取用户订单
export function getUserOrder(params) {
    return requestCustom({
        url: `/sessionList/getUserOrderList`,
        method: 'get',
        params: params
    })
}

//客服列表
export function getCustomerList() {
    return requestGo({
        url: `/im/msg/getKefu`,
        method: 'get'
    })
}

//创建群聊
export function createGroup(data) {
    const body = normalizeGoGroupPayload(data)
    return requestGo({
        url: `/im/msg/createPublicGroupIM`,
        method: 'post',
        data: body
    })
}

function normalizeGoGroupPayload(data = {}) {
    const members = normalizeGroupMembers(data.members)
    const owner = data.owner || data.buyer
    if (owner && !members.includes(owner)) {
        members.unshift(owner)
    }
    return {
        groupName: data.groupName || data.groupname || data.name || '新建群组',
        groupDesc: data.groupDesc || data.description || data.desc || '',
        groupType: data.groupType || 'customGroup',
        otherId: data.other || data.otherId || data.no || '',
        groupCategory: data.groupCategory,
        members
    }
}

function normalizeGroupMembers(members) {
    if (!members) return []
    let list = members
    if (typeof members === 'string') {
        try {
            list = JSON.parse(members)
        } catch (e) {
            list = members.split(',')
        }
    }
    if (!Array.isArray(list)) return []
    return list
        .map((item) => {
            if (typeof item === 'string') return item
            return item.hxid || item.hxId || item.hxusername || item.value || ''
        })
        .filter(Boolean)
}

//移入分组
export function updateByToGroup(data) {
    return requestGo({
        url: `/group/info/updateSettings`,
        method: 'post',
        data: {
            groupId: data.groupId || data.toGroup,
            groupCategory: data.groupCategory
        }
    })
}

//获取群组成员信息
export function getGroupMemberInfo(groupId, fromHxId) {
    return requestCustom({
        url: `/other/getOtherGroupInfo?groupId=${groupId}&fromHxId=${fromHxId}`,
        method: 'get'
    })
}
//增加呼叫卖家
export function callSeller(toGroup) {
    return requestCustom({
        url: `/sessionList/sendVoice?toGroup=${toGroup}&type=呼叫卖家`,
        method: 'get'
    })
}

//增加呼叫买家
export function callBuyer(toGroup) {
    return requestCustom({
        url: `/sessionList/sendVoice?toGroup=${toGroup}&type=呼叫买家`,
        method: 'get'
    })
}

//增加手动点击拨打电话
export function callPhone(phone, type) {
    return requestCustom({
        url: `/sms/sendVoice?phone=${phone}&type=${type}`,
        method: 'get'
    })
}
